import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isEmpty } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { homePageCategorySection } from "../../../../../../../utils/constants";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { closeEditModal } from "../../../../../../../store/redux/slice/ComponentsControl/homePageCategoryControl";
import EditCategoryDialogBody from "./EditCategoryDialogBody";

const EditCategoryDialog = () => {
  const dispatch = useAppDispatch();

  const { open, object } = useAppSelector((state) => {
    return state.ComponentsControl.homePageCategoryControl.sections[homePageCategorySection.category].modals.edit;
  });

  const handleCloseDialog = () => {
    dispatch(closeEditModal({ section: homePageCategorySection.category }));
  };

  const { t } = useTranslation();
  const isEditMode = !isEmpty(object.id);

  return (
    <div>
      <Dialog
        PaperProps={{ sx: { position: "fixed", top: "10%", m: 0 } }}
        open={open}
        fullWidth={true}
        maxWidth={"lg"}
        onClose={() => handleCloseDialog()}
        aria-labelledby="home-page-category-edit-dialog-title"
      >
        <DialogTitle id="home-page-category-edit-dialog-title" style={{ textAlign: "center" }}>
          {!isEditMode && t("t.homePageCategory.create.dialog")}
          {isEditMode && t("t.homePageCategory.edit.dialog")}
        </DialogTitle>
        <DialogContent>
          <EditCategoryDialogBody category={object} setOpen={handleCloseDialog} isEditMode={isEditMode} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EditCategoryDialog;
